export default {"src":"/_next/static/media/yapay.26306641.svg","height":20,"width":58,"blurWidth":0,"blurHeight":0};